import { render, staticRenderFns } from "./WorkflowTimeline.vue?vue&type=template&id=bb12bb50&scoped=true"
import script from "./WorkflowTimeline.vue?vue&type=script&lang=js"
export * from "./WorkflowTimeline.vue?vue&type=script&lang=js"
import style0 from "./WorkflowTimeline.vue?vue&type=style&index=0&id=bb12bb50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb12bb50",
  null
  
)

export default component.exports